<div class="flex flex-col items-center gap-6">
  <div class="flex w-full flex-col">
    <div class="flex flex-wrap items-center gap-1 font-poppins text-[24px] font-medium leading-[30px] tracking-[-0.7px] xs:h-[45px]">
      <span class="text-[#595959]">{{ 'ascend_eaglesoft_blocker_title_prefix' | translate }}</span>
      <span class="text-background">{{ 'ascend_eaglesoft_blocker_title_accent' | translate }}</span>
      <img class="h-[26px]" src="assets/images/logo-no-padding.svg" alt="FFD" />
    </div>

    <p class="font-poppins text-[14px] font-light leading-[1.3] text-[#969696]">
      {{ 'ascend_eaglesoft_blocker_subtitle' | translate }}
    </p>
  </div>

  <div class="flex w-full items-start gap-3 rounded-[16px] bg-[#F5F0FB] px-4 py-3">
    <div class="flex size-8 shrink-0 items-center justify-center rounded-[100px] bg-[rgba(145,69,241,0.1)]">
      <svg-icon class="flex text-states-purple" key="px-24-iphone" size="md"></svg-icon>
    </div>
    <div class="flex min-w-0 flex-1 flex-col gap-1 pt-[3px] text-text-secondary">
      <span class="typo-h5-semibold">{{ 'ascend_eaglesoft_blocker_notes_title' | translate }}</span>
      <span class="typo-h5-book leading-[18px]">{{ 'ascend_eaglesoft_blocker_notes_description' | translate }}</span>
    </div>
  </div>

  <div class="flex flex-col items-center justify-center gap-4 xs:flex-row xs:gap-[30px]">
    <img class="h-[220.575px] w-[170.46px]" src="assets/images/ascend-eaglesoft-blocker-phones@2x.png" alt="" />

    <div class="flex flex-col items-center">
      <div class="overflow-hidden rounded-[13px]">
        <qrcode
          [qrdata]="appStoreUrl"
          [width]="qrCodeSize"
          [errorCorrectionLevel]="'L'"
          [margin]="3"
          [allowEmptyString]="true"
          [elementType]="'canvas'"
          [imageSrc]="'assets/images/logo-qr-black.png'"
          [imageHeight]="qrCodeLogoSize"
          [imageWidth]="qrCodeLogoSize"
        ></qrcode>
      </div>

      <a
        class="typo-h4-semibold flex items-center gap-1 text-states-purple-dark"
        [href]="appStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'ascend_eaglesoft_blocker_get_app_link' | translate }}
        <svg-icon key="px-24-apple" size="md"></svg-icon>
      </a>
    </div>
  </div>

  <!-- Figma insets this row 4px past the 48px card padding, so the button is 417px inside a 409px column.
       The 24px flex gap already covers the row's own 16px top offset. -->
  <div class="-mx-1 -mt-2 w-[calc(100%+8px)]">
    <button class="btn-primary h-10 w-full justify-center" type="button" (click)="onDoneClick()">
      {{ 'ascend_eaglesoft_blocker_done_button' | translate }}
    </button>
  </div>
</div>
